// VARIABLES
// LANG
export const NEXT_LOCALE = "NEXT_LOCALE";

// EXPERIENCE
export const EXPERIENCE_PER_PAGE = 2;

// COLORS
export const MAIN_COLOR = "#800020";
export const SECONDARY_COLOR = "#c20e35";

// BOX REVEAL
export const BOX_REVEAL_DELAY = 0.3;

// MAGNET
export const MAGNET_PADDING = 200;
export const MAGNET_STRENGTH = 5;

// WORD ROTATE
export const WORD_ROTATE_DURATION = 2000;

// LISTS
export const NavList = [
  {
    id: 1,
    title: "Home",
    href: "/",
  },
  {
    id: 2,
    title: "About",
  },
  {
    id: 3,
    title: "Experience",
  },
  {
    id: 4,
    title: "Projects",
  },
  {
    id: 5,
    title: "Skills",
  },
  {
    id: 6,
    title: "Testimonials",
  },
  {
    id: 7,
    title: "Contact",
  },
];

export const langItems = [
  {
    value: "en",
    label: "English",
    flag: "/us.svg",
  },
  {
    value: "ar",
    label: "العربية",
    flag: "/eg.svg",
  },
  {
    value: "es",
    label: "Español",
    flag: "/es.svg",
  },
  {
    value: "it",
    label: "Italiano",
    flag: "/it.svg",
  },
  {
    value: "fr",
    label: "Français",
    flag: "/fr.svg",
  },
  {
    value: "pt",
    label: "Português",
    flag: "/pt.svg",
  },
  {
    value: "de",
    label: "Deutsch",
    flag: "/de.svg",
  },
];

export const tourGuideData: Record<
  number,
  { text: string; side: "left" | "right" }
> = {
  1: {
    text: "header",
    side: "right",
  },
  2: {
    text: "about",
    side: "right",
  },
  3: {
    text: "experience",
    side: "left",
  },
  4: { text: "projects", side: "right" },
  5: { text: "skills", side: "left" },
  6: {
    text: "testimonials",
    side: "right",
  },
  7: { text: "contact", side: "left" },
};



// FILTER

export const projectTypeFilterOptions = [
  { label: "Personal", value: "personal" },
  { label: "Work", value: "work" },
  { label: "Freelance", value: "freelance" },
];

export const liveDemoFilterOptions = [
  { label: "Available", value: "available" },
  { label: "Not Available", value: "unavailable" },
];

export const dashboardSidebarCollapseContent = [
  {
    id: 1,
    title: "Header",
    href: "/admin/header",
  },
  {
    id: 2,
    title: "About",
    href: "/admin/about",
  },
  {
    id: 3,
    title: "Experience",
    href: "/admin/experience",
    containsViews: true,
  },
  {
    id: 4,
    title: "Projects",
    href: "/admin/projects",
    containsViews: true,
  },
  {
    id: 5,
    title: "Skills",
    href: "/admin/skills",
    containsViews: true,
  },
  {
    id: 6,
    title: "Testimonials",
    href: "/admin/testimonials",
    notContainsAdd: true,
    containsViews: true,
  },
];

export const settingsSidebarContent = [
  {
    id: 1,
    title: "Add",
    children: [
      {
        label: "Add Global Info",
        href: "/admin/settings/add/global-info",
      },
      {
        label: "Add New Track",
        href: "/admin/settings/add/new-track",
      },
    ],
  },
  {
    id: 2,
    title: "View",
    children: [
      {
        label: "View Tracks",
        href: "/admin/settings/view/tracks",
      },
    ],
  },
];
